document.addEventListener('DOMContentLoaded', function () {
  const GIFT_BOX_VARIANTS = {
    simple: 45645210681397,
    premium: 45694850138165
  };
  const ALL_GIFT_VARIANT_IDS = Object.values(GIFT_BOX_VARIANTS);

  function getCurrentGiftSelection(cart) {
    const item = cart.items.find(i => ALL_GIFT_VARIANT_IDS.includes(i.variant_id));
    if (!item) return 'none';
    return item.variant_id === GIFT_BOX_VARIANTS.simple ? 'simple' : 'premium';
  }

  function initGiftBoxRadios(radioGroup) {
    if (!radioGroup || radioGroup.dataset.giftBoxInit) return;
    radioGroup.dataset.giftBoxInit = 'true';

    const radios = radioGroup.querySelectorAll('input[type="radio"]');

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const current = getCurrentGiftSelection(cart);
        radios.forEach(r => { r.checked = (r.value === current); });
      });

    radios.forEach(radio => {
      radio.addEventListener('change', function () {
        if (!this.checked) return;
        const selection = this.value;

        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            const existingGiftItem = cart.items.find(i => ALL_GIFT_VARIANT_IDS.includes(i.variant_id));
            const removePromise = existingGiftItem
              ? fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: existingGiftItem.key, quantity: 0 })
                })
              : Promise.resolve();

            removePromise.then(() => {
              if (selection === 'none') {
                window.location.reload();
                return;
              }
              const variantId = GIFT_BOX_VARIANTS[selection];
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
              })
                .then(() => window.location.reload())
                .catch(err => console.error('Erreur ajout box cadeau:', err));
            });
          });
      });
    });
  }

  document.querySelectorAll('.gift-box-radio-group').forEach(initGiftBoxRadios);

  document.addEventListener('cart:updated', function () {
    document.querySelectorAll('.gift-box-radio-group').forEach(initGiftBoxRadios);
  });
});